import { useState } from "react";
import Head from "next/head";
import Link from "next/link";
import useUser from "../lib/useUser";
import { Layout } from "../common/Layout";
import { Imgix, Hero, Section } from "../common/UI";
import withSession from "../lib/session";
import {
  Container,
  Grid,
  Button,
  Box,
  Typography,
  Divider,
} from "@mui/material";

import { PartnersList } from "../modules/Partners/List";

export default function SurfCampPage() {
  return (
    <Layout>
      <Grid item>
        <Hero
          minHeight={400}
          bgImg="https://bigsurf1public.imgix.net/public/a9f660fb-bfd3-42c6-8956-e13f92541178.jpg?auto=format&fit=crop&crop=focalpoint&ar=4%3A3&ixlib=react-9.3.0&height=500"
        >
          <Box sx={{}}>
            <Typography
              variant="h2"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Summer Surf Camp
            </Typography>
          </Box>
          <Box sx={{}}>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              3-day and 5-day exciting surf camps for kids
            </Typography>
          </Box>
        </Hero>

        <Section id="zane">
          <Container>
            <Grid container>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  {/* <Typography variant="h4">Zane Reed</Typography> */}
                  <Typography variant="h5">
                    {/* Instructor, Owner of Big Surf Adventures */}
                    <Link
                      target="_blank"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSfjhelT5D4q77jy_huA2mi17UJUDAJ9yUZsCI7YiTo-jHIg8w/viewform?usp=dialog"
                    >
                      Sign up using this link
                    </Link>
                  </Typography>
                  <ul>
                    <li>3-Day / 5-Day Camps</li>
                    <li>2 Hour Lessons Each Day </li>
                    <li>All Equipment Included</li>
                    <li>Student to Instructor Ratio is 4:1 (often less)</li>
                    <li>Patient, supportive and professional instructors </li>
                    <li>Lifeguard Certified</li>
                    <li>Fully Insured and Licensed Surf School </li>
                    <li>Never settle for less</li>
                    <li>Ages 6 to 17</li>
                  </ul>

                  <p>
                    Kids will be grouped based on surfing ability and age. We
                    will provide extra towels and water and granola bars or
                    similar on the beach for any kids that get tired or want to
                    end a little early. We also will have a designated
                    photographer who is also a trained ocean lifeguard that will
                    be taking pictures and keeping an extra watchful eye on the
                    lessons in addition to the instructors.
                  </p>
                  <p>
                    The location for surf camp will vary based on the ocean
                    conditions as we will always select the safest location with
                    the best waves for beginners. Our locations include - Del
                    monte beach, Monterey Municipal beach, Asilomar Beach, and
                    Carmel beach. Decisions on location will be given days in
                    advance to allow for plenty of time to coordinate/plan
                    pickup and drop off.
                  </p>

                  <p style={{}}>- 3-Day Camp Price: $225</p>
                  <p style={{}}>- 5-Day Camp price $350</p>
                  <p style={{}}>
                    - Use your own equipment and save $10 per day!
                  </p>
                  <p style={{}}>
                    Custom camp dates are available. Have your own group of kids
                    and want to set up a custom camp date? Email us:{" "}
                    <Link href="mailto:hello@bigsurfadventures.com">
                      hello@bigsurfadventures.com
                    </Link>
                  </p>
                  <p style={{}}>
                    Late pickups will incur fees at a rate of $15 for every 15
                    minutes late as we will not release kids unsupervised.
                  </p>
                  <p>
                    <Button
                      // onClick={handleAccept}
                      target="_blank"
                      href="https://docs.google.com/forms/d/e/1FAIpQLSfjhelT5D4q77jy_huA2mi17UJUDAJ9yUZsCI7YiTo-jHIg8w/viewform?usp=dialog"
                      color="info"
                      variant="contained"
                      sx={{ width: "100%" }}
                    >
                      Sign Up Today!
                    </Button>
                  </p>
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box sx={{ margin: "24px" }}>
                  <Imgix
                    src="https://bigsurf1public.imgix.net/public/b4e530f5-c5ba-48e6-a7fd-602427c796b5.jpg"
                    width={600}
                  />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />

        <Hero minHeight={400} bg="#35baf6">
          <Typography
            variant="h2"
            sx={{
              color: "white",
              textShadow: "0 1px 0 black",
              textAlign: "center",
            }}
          >
            Whether it's your first time or you're eager to improve your skills,
            <br />
            Big Sur Surf Lessons will accommodate your learning needs!
          </Typography>
        </Hero>
      </Grid>
    </Layout>
  );
}

// export const getServerSideProps = withSession(async function ({ req, res }) {
//   const user = req.session.get("user") ?? null;
//   return {
//     props: { user },
//   };
// });
